const menuPage = {
  'menuPage-title': 'Our Menu'
};

export default menuPage;
